/** Thin seam over `location.assign` so tests can observe navigation (jsdom can't). */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
